import { createReducer } from 'redux-act';

import { initSegmentIdentity, loadSegmentSuccess } from './globalSettings.actions';

export interface IGlobalSettingsState {
  isSegmentLoaded: boolean;
  isSegmentInit: boolean;
}

export const initialState: IGlobalSettingsState = {
  isSegmentLoaded: false,
  isSegmentInit: false,
};

const reducer = createReducer<IGlobalSettingsState>({}, initialState);

reducer
  .on(loadSegmentSuccess, state => ({
    ...state,
    isSegmentLoaded: true,
  }))
  .on(initSegmentIdentity, state => ({
    ...state,
    isSegmentInit: true,
  }));

export default reducer;
